<template>
  <div class="hello">
    <div>
      <keep-alive>
        <router-view v-on="$listeners" v-if="$route.meta.keepLive" />
        </keep-alive>
      <router-view v-on="$listeners" v-if="!$route.meta.keepLive" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["navList"],
  data() {
    return {
      nav: "",
    };
  },
  mounted() {},
  watch: {
  },
};
</script>

<style scoped>
.hello {
  margin: 10px;
  padding: 0 10px;
  height: calc(100vh - 60px - 20px);
  overflow-y: auto;
  /*background: #fff;*/
}
::v-deep .hello_title {
  height: 40px;
  line-height: 40px;
}
</style>
